import { FetchPolicy, useLazyLoadQuery } from "react-relay"
import { Language } from "@/modules/patients/services/__generated__/PatientAppointmentFragment.graphql"
import { chPatientEpisodesOfCareQuery } from "@/modules/patients/services/ch/__generated__/chPatientEpisodesOfCareQuery.graphql"
import { chPatientEpisodesOfCareQuery as chQuery } from "@/modules/patients/services/ch/chPatientEpisodesOfCareQuery"
import { dePatientEpisodesOfCareQuery } from "@/modules/patients/services/de/__generated__/dePatientEpisodesOfCareQuery.graphql"
import { dePatientEpisodesOfCareQuery as deQuery } from "@/modules/patients/services/de/dePatientEpisodesOfCareQuery"
import { Country, ProgressNoteKind } from "@/types/__generated__/union-types"

export const usePatientEpisodesOfCareQuery = (
  patientId: string,
  appointmentId: string | null,
  shouldCreateDraftProgressNote: boolean,
  country: Country,
  kind: ProgressNoteKind,
  language: Language,
  fetchKey?: number,
  fetchPolicy?: FetchPolicy,
) => {
  const query = country === "DE" ? deQuery : chQuery
  const data = useLazyLoadQuery<dePatientEpisodesOfCareQuery | chPatientEpisodesOfCareQuery>(
    query,
    {
      patientId,
      appointmentId,
      shouldCreateDraftProgressNote,
      kind,
      language,
    },
    {
      fetchKey: fetchKey ?? 0,
      fetchPolicy,
    },
  )

  return [data]
}
